import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Session.
import VueSession from 'vue-session'

// Import dialogue requirements.
import * as VueWindow from '@hscmap/vue-window'

// Import ACL requirements.
import ability from './acl'
import { abilitiesPlugin } from '@casl/vue'

// FontAwesome.
library.add(faUserSecret)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vuetify icons.
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// TODO: Come back to this!!!
// WebSocket support.
// import VueSocketIO from 'vue-socket.io'
// import SocketIO from 'socket.io-client'
// const socket = new VueSocketIO({
//   debug: true,
//   connection: SocketIO('wss://dev.api.casterdepot.com/ws')
// })

Vue.use(VueSkycons, {color: "#1e88e5",});
Vue.use(VueSession)
Vue.use(VueWindow)
Vue.use(abilitiesPlugin, ability)
// Vue.use(socket)

Vue.config.productionTip = false;
Vue.use(Vuebar);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
  beforeCreate () {
    // Redirect all requests to /login if the user has not logged in.
    if (!this.$session.exists() && this.$router.history.current.path !== '/login') {
      this.$router.push('/login')
    }
  }
}).$mount("#app");
